// Faces
const facelist = [

	require('./faces/1.png'),
	require('./faces/2.png'),
	require('./faces/3.png'),
	require('./faces/4.png'),
	require('./faces/5.png'),
	require('./faces/6.png'),

]


// Eyes
const eyeslist = [

	require('./eyes/1.png'),
	require('./eyes/2.png'),
	require('./eyes/3.png'),
	require('./eyes/4.png'),
	require('./eyes/5.png'),
	require('./eyes/6.png'),

]


// Backgrounds
const bglist = [

	require('./bgs/1.png'),
	require('./bgs/2.png'),
	require('./bgs/3.png'),
	require('./bgs/4.png'),
	require('./bgs/5.png'),
	require('./bgs/6.png'),
]




// HairStyles
const hairlist = [

	require('./hair/1.png'),
	require('./hair/2.png'),
	require('./hair/3.png'),
	require('./hair/4.png'),
	require('./hair/5.png'),
	require('./hair/6.png'),
	require('./hair/7.png'),
	require('./hair/8.png'),
	require('./hair/9.png'),
	require('./hair/10.png'),
	require('./hair/11.png'),
	require('./hair/12.png'),
	require('./hair/13.png'),
	require('./hair/14.png'),
	require('./hair/15.png'),
	require('./hair/16.png'),
	require('./hair/17.png'),
	require('./hair/18.png'),

]


// Beards
const faciallist = [

	require('./facialhair/1.png'),
	require('./facialhair/2.png'),
	require('./facialhair/3.png'),
	require('./facialhair/4.png'),
	require('./facialhair/5.png'),
	require('./facialhair/6.png'),
	require('./facialhair/7.png'),
	require('./facialhair/8.png'),
	require('./facialhair/9.png'),

]


export {
	hairlist, 
	bglist, 
	faciallist,
	facelist,
	eyeslist
};
